/**
 * Department-related constants
 */

export const DEFAULT_DEPARTMENT_NAME = 'ALL';
export const DEFAULT_DEPARTMENT_ID = '01J0000000000000000000000';
